import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Anthem Blue Cross of California",
  shortName: "Anthem CA",
  slug: "anthem-ca-insurance",
  seoTitle:
    "Anthem Blue Cross of California TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Anthem Blue Cross of California policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "Anthem CA TMS coverage, Anthem California SPRAVATO authorization, Anthem CA mental health benefits Coral Springs FL, Anthem California depression treatment Florida",
};

export const AnthemCaInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default AnthemCaInsurance;
